import createDecorator from 'final-form-calculate'
import { MetaPath, MetaRoot } from 'util/metaPath'
import { limparHorarioFinal } from 'view/agenda/cadastro-agendamento/calculator-agenda'

import { GarantiaAcessoAgendaModel } from './GarantiaAcessoAgendarConsultaModalForm'

export const createAgendarConsultaCalculations = (
  name: MetaPath<GarantiaAcessoAgendaModel> | MetaRoot<GarantiaAcessoAgendaModel>
) =>
  createDecorator(
    {
      field: name.agendamentoConsultaInput.lotacao.absolutePath(),
      updates: {
        [name.agendamentoConsultaInput.data.absolutePath()]: (
          lotacaoValue: string,
          allValues: GarantiaAcessoAgendaModel
        ) => lotacaoValue && allValues.agendamentoConsultaInput.data,
      },
    },
    {
      field: name.agendamentoConsultaInput.data.absolutePath(),
      updates: {
        [name.agendamentoConsultaInput.horario.absolutePath()]: (
          dataValue: string,
          allValues: GarantiaAcessoAgendaModel
        ) => dataValue && allValues.agendamentoConsultaInput.horario,
      },
    },
    {
      field: name.agendamentoConsultaInput.horario.inicial.absolutePath(),
      updates: {
        [name.agendamentoConsultaInput.horario.final.absolutePath()]: limparHorarioFinal,
      },
    },
    {
      field: name.lotacaoResponsavel.absolutePath(),
      updates: {
        [name.agendamentoConsultaCompartilhadaInput.data.absolutePath()]: (
          lotacaoResponsavelValue: string,
          allValues: GarantiaAcessoAgendaModel
        ) => lotacaoResponsavelValue && allValues.agendamentoConsultaCompartilhadaInput.data,
      },
    },
    {
      field: name.agendamentoConsultaCompartilhadaInput.lotacaoConvidada.absolutePath(),
      updates: {
        [name.agendamentoConsultaCompartilhadaInput.data.absolutePath()]: (
          lotacaoConvidadaValue: string,
          allValues: GarantiaAcessoAgendaModel
        ) => lotacaoConvidadaValue && allValues.agendamentoConsultaCompartilhadaInput.data,
      },
    },
    {
      field: name.agendamentoConsultaCompartilhadaInput.horario.inicial.absolutePath(),
      updates: {
        [name.agendamentoConsultaCompartilhadaInput.horario.final.absolutePath()]: limparHorarioFinal,
      },
    }
  )
